import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { isAdmin } from "../constants.js";
import "./NewBrand.css";

export default function NewBrand({ config, onCreateBrand, isSavingBrand }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [websiteUrl, setWebsiteUrl] = useState("");
  const [error, setError] = useState(null);

  if (!isAdmin(config.userRole)) {
    return (
      <div className="new-brand">
        <h1 className="new-brand__title">New brand</h1>
        <p className="new-brand__role-notice">Only admins can create a new brand.</p>
        <Link to="/brands" className="new-brand__back-link">
          ← Back to Brands
        </Link>
      </div>
    );
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!name.trim()) return;
    setError(null);

    try {
      // Navigates using the server-assigned slug, not a locally-guessed
      // one - the backend owns slug-collision handling (e.g. "-2" for a
      // duplicate name), which the client has no way to predict
      // correctly on its own.
      const brand = await onCreateBrand(name, websiteUrl);
      navigate(`/brands/${brand.slug}`);
    } catch (err) {
      setError("Couldn't create this brand. Please try again.");
    }
  }

  return (
    <div className="new-brand">
      <h1 className="new-brand__title">New brand</h1>
      <p className="new-brand__subtitle">
        Just the basics for now — voice, USPs, and compliance rules come next.
      </p>

      <form className="new-brand__form" onSubmit={handleSubmit}>
        <label className="new-brand__field">
          <span>Brand name</span>
          <input
            type="text"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="e.g. Acme Retail"
            required
          />
        </label>

        <label className="new-brand__field">
          <span>Website URL</span>
          <input
            type="url"
            value={websiteUrl}
            onChange={(event) => setWebsiteUrl(event.target.value)}
            placeholder="https://"
          />
        </label>

        {error ? <p className="new-brand__error">{error}</p> : null}

        <div className="new-brand__actions">
          <button
            type="button"
            className="new-brand__cancel"
            onClick={() => navigate("/brands")}
            disabled={isSavingBrand}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn--primary" disabled={isSavingBrand}>
            {isSavingBrand ? "Creating…" : "Create brand"}
          </button>
        </div>
      </form>
    </div>
  );
}